export default {
  applies_to_articles: 'Se aplica a los siguientes artículos',
};
